import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { useProgressBar } from './useProgressBar'

interface Props {
  healthy: number
  warning: number
  broken: number
}

export const StatusProgressBar: React.FC<Props> = ({
  healthy,
  warning,
  broken,
}) => {
  const { visibleSegments, getWidth } = useProgressBar(healthy, warning, broken)

  return (
    <div className={css.status_progress}>
      {visibleSegments.map(({ id, value }) => (
        <div
          key={id}
          className={clsJoin(css.status_progress_segment, css[id])}
          style={{ width: getWidth(value) }}
        />
      ))}
    </div>
  )
}
